import { render, staticRenderFns } from "./DashboardMain.vue?vue&type=template&id=a263546e&scoped=true&"
import script from "./DashboardMain.vue?vue&type=script&lang=js&"
export * from "./DashboardMain.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMain.vue?vue&type=style&index=0&id=a263546e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a263546e",
  null
  
)

export default component.exports